export interface FrameworkRung {
  letter: string;
  name: string;
  desc: string;
}

export interface LadderRung {
  name: string;
  desc: string;
}

export const framework: FrameworkRung[] = [
  {
    letter: 'S',
    name: 'Specify with evals',
    desc: 'Write the evals that define "good" for your top three workflows. If you cannot write the eval, you cannot ship the agent.',
  },
  {
    letter: 'H',
    name: 'Harness the loop',
    desc: 'Pick agent runtime, model gateway, memory layer. Standardise on two coding agents, one gateway, one SDK. MCP as the default integration shape.',
  },
  {
    letter: 'I',
    name: 'Instrument everything',
    desc: 'OpenTelemetry GenAI conventions on day one. Default content capture off, redact at the Collector. Capture tokens and tool selection always.',
  },
  {
    letter: 'F',
    name: 'FinOps the tokens',
    desc: 'Per-agent-task cost is a first-class SLO. Per-team budgets, complexity-based routing, circuit breakers, weekly unit economics.',
  },
  {
    letter: 'T',
    name: 'Trust, then transfer',
    desc: 'Move workloads up the autonomy ladder one rung at a time, gated by eval threshold + cost ceiling + red-team sign-off.',
  },
];

export const ladder: LadderRung[] = [
  { name: 'Suggest', desc: 'Agent proposes; human always acts.' },
  {
    name: 'Draft',
    desc: 'Agent acts in a sandbox; human reviews before merge.',
  },
  {
    name: 'Execute (bounded)',
    desc: 'Agent acts in production within a typed, audited tool set; human samples.',
  },
  {
    name: 'Operate',
    desc: 'Agent acts autonomously within a budget and policy; human paged on threshold breach.',
  },
  {
    name: 'Delegate',
    desc: 'Agent owns the outcome end-to-end; human reviews aggregate metrics.',
  },
];
